import React, { Component } from "react";
import {getItems} from "../services/saleService";
import { formatNumber } from "../services/util";
import SaleItemDetails from './saleItemDetails';
import SaleSummary from './saleSummary';

class Sale extends Component {
  state = {
    items: [],
    selectedItem: {},
    saleItems: [],
    total: 0,
  };

  async componentDidMount() {
    try {
      const { data } = await getItems();

      this.setState({ items: data });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        this.props.history.replace("/main/404");
      } else if (ex.response && ex.response.status === 403) {
        this.props.history.replace("/main/403");
      } else if (ex.response && ex.response.status === 500) {
        this.props.history.replace("/main/500");
      }
    }
  }

  handleItemSelection = (item) => {
    this.setState({ selectedItem: item });
  };

  resetSale = () => {
    this.setState({ selectedItem: {}, saleItems: [], total: 0 });
  };

  addSaleItem = (data) => {
    const { saleItems, selectedItem, total } = this.state;
    let amount = 0;
    let saleItem = {};
      amount = data.quantity * selectedItem.price;
      saleItem = {
        itemId: selectedItem._id,
        name: selectedItem.name,
        price: selectedItem.price,
        quantity: data.quantity,
        amount
      };
    saleItems.push(saleItem);
    const newTotal = total + amount;

    this.setState({ saleItems, total: newTotal });
  };

  render() {
    const { items, selectedItem, saleItems, total } = this.state;
    const customerId = this.props.match.params.id;

    return (
      <React.Fragment>
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="card mb-3">
              <div className="card-header">
                <i className="fas fa-table mr-2" />
                Item List
              </div>
              <div className="card-body">
                <ul className="list-group pointer-cursor">
                  {items.map((item) => (
                    <li
                      key={item._id}
                      onClick={() => this.handleItemSelection(item)}
                      className={item === selectedItem ? "list-group-item active" : "list-group-item"}
                    >
                      {item.name} - &#x20A6;{formatNumber(item.price)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <SaleItemDetails item={selectedItem} callBackFromParent={this.addSaleItem} />
          </div>
          <div className="col-md-5">
            <SaleSummary
              items={saleItems}
              total={total}
              customerId={customerId}
              callBackFromParent={this.resetSale}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Sale;